// frontend/src/components/Requisitions/edit/components/ManualUomWarning.jsx

import React from "react";

export default function ManualUomWarning({ unitLabel }) {
  return (
    <div
      style={{
        background: "#FFF3CD",
        border: "1px solid #FFEEBA",
        color: "#856404",
        padding: "10px 12px",
        borderRadius: 10,
        marginBottom: 12,
        lineHeight: 1.35,
      }}
    >
      <div style={{ fontWeight: 700, marginBottom: 4 }}>
        ⚠️ Importante (Licitación: NO APLICA)
      </div>

      <div>
        La <b>descripción</b> que captures debe <b>coincidir con la Unidad de
        Medida</b> (cuando aplique). Si cambias la unidad, revisa y ajusta la
        descripción para que sea consistente.
      </div>

      {unitLabel ? (
        <div style={{ marginTop: 6, fontSize: 13 }}>
          Unidad seleccionada: <b>{unitLabel}</b>
        </div>
      ) : null}
    </div>
  );
}